import { XauditModel } from '../../../models/xaudit.model';

export class CaseTooth extends XauditModel {
  PatientCaseId: string;
  CaseWorkItemId: string;
  CaseDescription: string;
  CaseWorkItemToothId: string;
  ToothId: string;
  Notation: string;
  NotationDescription: string;
  
}
